// ink-component
import React from 'react';

import { IconTypes } from '../../../../helpers/constants';
import { MessageAttachmentWrapper } from '../../styles';

import getGlobalProps from '../../../../helpers/constants/global-props';

import Icon from '../../../Icon/Icon';

export interface MessageAttachmentProps extends React.HTMLAttributes<HTMLDivElement> {
  /** [Icon](/components/Icon/usage) that represents file attachment */
  iconType?: IconTypes;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Message attachment
 * @group Message
 */
function MessageAttachment(props: MessageAttachmentProps) {
  const { style, className, children, iconType, ...otherProps } = props;

  return (
    <MessageAttachmentWrapper {...globalProps} {...otherProps}>
      <Icon size="lg" type={iconType} />
      {children}
    </MessageAttachmentWrapper>
  );
}

MessageAttachment.defaultProps = {
  iconType: 'paperclip',
};

MessageAttachment.displayName = 'Message.Attachment';

export default MessageAttachment;
